import BadgeList, { BadgeListProps } from '@cas/components/tables/cells/badge-list/BadgeList';
import { CustomCellRendererProps } from 'ag-grid-react';
import { ReactElement } from 'react';

type CellBadgeListRendererProps = {
  value: CustomCellRendererProps<object, string | string[]>['value'];
  statusColor?: BadgeListProps['statusColor'];
};

export const CellBadgeListRenderer = ({
  value,
  statusColor,
}: CellBadgeListRendererProps): ReactElement => {
  const normalizedItems: string[] = typeof value === 'string' ? [value] : (value ?? []);

  return <BadgeList items={normalizedItems} statusColor={statusColor} />;
};
